'use strict';

ReadMoreLessToggle.$inject = [];
function ReadMoreLessToggle() {
  return {
    restrict: 'A',
    link: function(scope, element) {
      scope.$watch(function () {
      }, function () {
        if (element.children()[0].offsetHeight > 100) {
          angular.element(element.children()[0]).addClass('short-text');
          scope.showMore = true;
        }
      });

      angular.element(element.children()[1]).on("click", function(){
        scope.showMore = false;
        scope.showLess = true;
        angular.element(element.children()[0]).removeClass('short-text');
      });
      angular.element(element.children()[2]).on("click", function(){
        scope.showMore = true;
        scope.showLess = false;
        angular.element(element.children()[0]).addClass('short-text');
      });        
    }
  };
}

angular.module('dokiv')
  .directive('moreLessToggle', ReadMoreLessToggle);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/ReadMoreLessToggle.js
// module id = 248
// module chunks = 0